import { Chip } from "@platform/design-system";

interface RepStatusChipProps {
  active: boolean;
}

export const RepStatusChip = ({
  active,
}: RepStatusChipProps): React.JSX.Element =>
  active ? (
    <Chip
      label="Active"
      color="success"
      variant="subtle"
      size="small"
      leadingVisual={false}
    />
  ) : (
    <Chip
      label="Deactivated"
      variant="subtle"
      size="small"
      leadingVisual={false}
    />
  );
